Ext.define('SA.Assets', {
    singleton: true,

    getFileExtension(assetId) {
        return assetId.slice(assetId.lastIndexOf('.') + 1);
    },

    getMimeType(assetId) {
        return {
            pdf: 'application/pdf',
            png: 'image/png'
        }[this.getFileExtension(assetId).toLowerCase()];
    },

    getPath(assetId) {
        var data = encodeURIComponent(JSON.stringify({key: assetId})),
            format = encodeURIComponent(this.getMimeType(assetId));

        return `/dispatch.php?v=get&r=asset&d=${data}&f=${format}`;
    }
});
